@for (item of items; track $index; let i = $index) { @if (i !== 0) {
<div class="step-divider">
  @for (dash of dashes; track $index) {
  <span class="step-divider-dash" [ngClass]="item.status"></span>
  }
</div>
}
<div class="step-item" [ngClass]="item.status">
  @if(item.icon){
  <span
    nz-icon
    [nzType]="item.icon"
    nzTheme="fill"
    [ngStyle]="{ 'font-size': '32px' }"
  ></span>
  }
  <div class="flex-column">
    <span class="step-item-title" [ngClass]="item.status"
      >{{ item.title }}
      <span class="step-item-title-accent" [ngClass]="item.status">{{
        item.titleAccent
      }}</span>
    </span>
    <span class="step-item-description" [ngClass]="item.status">{{
      item.description
    }}</span>
  </div>
</div>
}
